import { Component, Inject, OnInit } from '@angular/core';
import { CurrentState } from './app.states';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { TitleCasePipe } from '@angular/common';
import * as titleCaseHelper from '../app/shared/title-case-helper';
import { SpinnerService } from './shared/services/spinner.service';
import { CancelService } from './core/services/cancel.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Eurofins.eQMS.WebUI';
  private eventSubscription?: Subscription;

  constructor(private readonly router: Router,
    private readonly titleService: Title,
    private readonly activatedRoute: ActivatedRoute,
    private readonly titleCasePipe: TitleCasePipe,
    private readonly spinnerService: SpinnerService,
    private readonly cancelService: CancelService
  ) {
    titleCaseHelper.setTitleCasePipe(this.titleCasePipe)
  }
  ngOnInit(): void {
    const appTitle = this.titleService.getTitle();
    
    // Reset spinner and cancel all polling on navigation start
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.cancelService.cancelAll();
        this.spinnerService.reset();
      });
    
    this.eventSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let newTitle = '';
          let child = this.activatedRoute.firstChild;
          while (child?.firstChild) {
            child = child.firstChild;
            if (child?.snapshot?.data['title']) {
              newTitle = `${newTitle}${newTitle ? ' - ' : ''}${child.snapshot.data['title']}`;
            }
          }
          return newTitle || appTitle;
        })
      )
      .subscribe((title: string) => {
        this.titleService.setTitle(title);
      });

    this.setupAngularRoutingForMiniSpa();
    this.goToState();
  }

  goToState() {
    var windowVar = window as any;
    if (windowVar['currentState']) {
      if (CurrentState[windowVar['currentState']]) {
        this.router.navigateByUrl(CurrentState[windowVar['currentState']]);
      }
    }
  }

  /**
   * Assigns the methods to window property for checking the client state and routing to it in mini-spa pattern
   * Apps rendered inside lims should set this to enable client side routing
   */
  setupAngularRoutingForMiniSpa() {
    window.angularApp = {
      goToState: this.goToState.bind(this),
      checkState: this.checkState.bind(this)
    };
  }

  /**
  * Checks if the state belongs to this app or not
  * Multiple angular apps are loaded into lims so this is to make sure that the state belongs
  * to the current opened angular app
  */
  checkState(state: string) {
    return CurrentState[state] ? true : false;
  }

  ngOnDestroy(): void {
    this.eventSubscription?.unsubscribe();
  }
}

/**
 * Sets the window and a property for mini-spa pattern to invoke clientside routing.
 */
declare global {
  interface Window {
    angularApp: {
      goToState: () => void;
      checkState: (state: string) => boolean;
    }
  }
}
